import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]
  static values = { templates: Object }

  apply() {
    const template = this.templatesValue[this.templateTarget.value]
    if (!template) return

    Object.entries(template.attributes || {}).forEach(([name, value]) => {
      const field = this.fieldFor(name)
      if (!field) return

      field.value = value
      field.dispatchEvent(new Event("input", { bubbles: true }))
      field.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  fieldFor(name) {
    const fieldName = `guided_fleet_asset[${name}]`
    return Array.from(this.element.elements).find((field) => field.name === fieldName)
  }
}
